import CategoriesCarouselSlider from './categories-carousel-slider';

export { CategoriesCarouselSlider as default };
